import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    marginTop: "20px",
    padding: "16px",
  },
  inputContainer: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    gap: 10,
  },
  title: { marginTop: 20, marginBottom: 5 },
  optionContainer: { marginBottom: 12 },
  optionLabel: { fontSize: 15 },
  subLabel: { fontSize: 13, fontWeight: 500 },
  visibilityOptions: {
    marginTop: 16,
    display: "flex",
    flexDirection: "column",
  },
  visibilityGroup: {
    marginTop: 12,
    marginLeft: 4,
    paddingLeft: 16,
  },
  radioRoot: {
    alignItems: "flex-start",
    marginBottom: 14,
    "& .MuiRadio-root": { paddingTop: 1.8 },
  },
});
